import React, { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Zap } from 'lucide-react';

export const TriggerNode = memo(({ data, isConnectable }: NodeProps) => {
  return (
    <div className="bg-white border-2 border-blue-200 rounded-lg shadow-sm min-w-[200px] hover:border-blue-500 transition-colors">
      <div className="bg-blue-50 border-b border-blue-100 p-2 rounded-t-md flex items-center gap-2">
        <div className="bg-blue-600 text-white p-1 rounded">
          <Zap className="h-3 w-3" />
        </div>
        <div className="flex flex-col">
          <div className="text-sm font-semibold text-gray-900">Event Trigger</div>
          {data?.label && (
            <div className="text-xs text-gray-500 font-medium">
              {data.label as string}
            </div>
          )}
        </div>
      </div>
      <div className="p-3">
        <div className="text-xs text-gray-500">
          Event: {(data?.config as any)?.eventType || 'Not configured'}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-blue-500 border-2 border-white"
      />
    </div>
  );
});

TriggerNode.displayName = 'TriggerNode';
